import axios from 'axios';
import { Result } from './Result';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content');

interface LoginResult {
    hash: string;
    sendCodeText: string;
    ttl: number;
}

interface LoginErrorResult {
    message: string;
    captchaMessage: string;
}

interface ConfirmResult {
    isConfirmed: boolean;
    redirectUrl?: string;
}

interface ConfirmErrorResult {
    errors: {
        firstName: boolean,
        lastName: boolean,
    };
    disabled: boolean;
}

interface SendCodeError {
    message: string;
    disabled: boolean;
    description: boolean;
}

class Auth {
    async auth(value: string, type: string, verifyCode: string): Promise<Result<LoginResult, LoginErrorResult>> {
        const resp = await axios.post('/login' + location.search, { [type]: value, type: type, verifyCode }, { withCredentials: true });
        const { data } = resp;
        if (data.status === 'success') {
            return new Result(true, data);
        }

        return new Result(false, null, data);
    }

    async sendCode(hash: string, code: string): Promise<Result<ConfirmResult, SendCodeError>> {
        const resp = await axios.post('/send-code' + location.search, { hash: hash, code: code });
        const { data } = resp;
        if (data.status === 'success') {
            return new Result(true, data);
        }

        return new Result(false, null, data);
    }

    async sendSms(hash: string): Promise<Result<LoginResult, SendCodeError>> {
        const resp = await axios.post('/login/send-sms' + location.search, { hash: hash });
        const { data } = resp;
        if (data.status === 'success') {
            return new Result(true, data);
        }

        return new Result(false, null, data);
    }

    async confirm(hash: string, firstName: string, lastName: string): Promise<Result<ConfirmResult, ConfirmErrorResult>> {
        const resp = await axios.post('/two-factor-auth' + location.search, { hash: hash, firstName: firstName, lastName: lastName });

        const { data } = resp;
        if (data.status === 'success') {
            return new Result(true, data);
        }

        return new Result(false, null, data);
    }

    async goHome(): Promise<void> {
        const response = await axios.get('/login/redirect' + location.search);

        location.href = response.data.redirectUrl;
    }

    async goRedirect(redirectUrl: string): Promise<void> {
        window.location.pathname = redirectUrl;
    }
}

const authApi = new Auth();

export { authApi };
